export const HeroBannerBetaProps = {
    titleColor: {
        type: String,
        default: '#fff',
    },
    subTitleColor: {
        type: String,
        default: '#fff',
    },
    titleMobileColor: {
        type: String,
        default: '#000',
    },
    subTitleMobileColor: {
        type: String,
        default: '#000',
    },
    subTitleAlign: {
        type: String,
        default: 'left',
    },
    titleAlign: {
        type: String,
        default: 'left',
    },
    titleDesktopFontSize: {
        type: String,
        default: '1.875rem',
    },
    titleMobileFontSize: {
        type: String,
        default: '16px',
    },
    subTitleDesktopFontSize: {
        type: String,
        default: '1.5rem',
    },
    subTitleMobileFontSize: {
        type: String,
        default: '10px',
    },
    gradientColor: {
        type: String,
        default: '#717171',
    },
    mobileGradientColor: {
        type: String,
        default: '#717171',
    },
    bannerHeight: {
        type: String,
        default: '360px',
    },
    bannerMobileHeight: {
        type: String,
        default: '100px',
    },
    hideSubtitleOnMobile: {
        type: Boolean,
        default: true,
    },
    hideSubtitleOnDesktop: {
        type: Boolean,
        default: false,
    },
};
